import { ActivatedRouteSnapshot } from '@angular/router';

export function getBaseUrl(
  fullPath: string,
  snapshot: ActivatedRouteSnapshot
): string {
  return `${
    fullPath.split(snapshot.routeConfig!.path!)[0]
  }${snapshot.routeConfig!.path!}`;
}
